export enum DashboardSearchType {
	Today = 0,
	Tomorrow = 1,
	Pending = 2,
}
